import { Route, Timer, Flag } from 'lucide-react';
import type { ItinerarySummary as Summary } from '@/types/itinerary';

/** Display the dot-separated clock style (10.00 not 10:00). */
function formatClock(t: string | null | undefined): string {
  return typeof t === 'string' ? t.replace(/:/g, '.') : '—';
}

/**
 * Stat chips for the generated plan — wahana count, total active duration, and
 * the finish time. Reads the backend `summary` directly (authoritative). Ported
 * from the reference `ItinerarySummary`, re-skinned to Tailwind/shadcn tokens.
 */
export function ItinerarySummary({ summary }: { summary: Summary | null }) {
  if (!summary) return null;

  const stats = [
    { icon: Route, value: String(summary.attractionCount ?? 0), label: 'Wahana', unit: '' },
    {
      icon: Timer,
      value: String(summary.totalDurationMinutes ?? 0),
      label: 'Total durasi',
      unit: 'mnt',
    },
    { icon: Flag, value: formatClock(summary.lastEndTime), label: 'Selesai', unit: '' },
  ];

  return (
    <div className="grid grid-cols-3 gap-2">
      {stats.map((s) => {
        const Icon = s.icon;
        return (
          <div
            key={s.label}
            className="rounded-md border-2 border-border bg-card px-3 py-2.5 text-center shadow-sm"
          >
            <Icon className="mx-auto mb-1 h-5 w-5 text-primary" />
            <p className="tnum text-lg font-bold leading-tight text-ink-900">
              {s.value}
              {s.unit && <span className="ml-0.5 text-xs font-semibold text-ink-400">{s.unit}</span>}
            </p>
            <p className="mt-0.5 text-[0.62rem] font-semibold uppercase tracking-widest text-ink-400">
              {s.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}
